'use client'

import { convertMinutesToMS } from '@sylveraio/react-utils'
import { SWRConfig } from 'swr'

export const SWRProvider = ({
  fetcher,
  children,
}: {
  fetcher: any
  children: React.ReactNode
}) => {
  return (
    <SWRConfig
      value={{
        refreshInterval: convertMinutesToMS(10),
        fetcher,
        revalidateOnFocus: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}
